import { render } from "./Container.vue?vue&type=template&id=4f0a2740"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"

import "./Container.vue?vue&type=style&index=0&id=4f0a2740&lang=css"
script.render = render

export default script